import { render, staticRenderFns } from "./DefaultBanner.vue?vue&type=template&id=c086163c&scoped=true"
import script from "./DefaultBanner.vue?vue&type=script&lang=js"
export * from "./DefaultBanner.vue?vue&type=script&lang=js"
import style0 from "./DefaultBanner.vue?vue&type=style&index=0&id=c086163c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c086163c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c086163c')) {
      api.createRecord('c086163c', component.options)
    } else {
      api.reload('c086163c', component.options)
    }
    module.hot.accept("./DefaultBanner.vue?vue&type=template&id=c086163c&scoped=true", function () {
      api.rerender('c086163c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/DefaultBanner.vue"
export default component.exports